module.exports = __webpack_public_path__ + "img/Niger.9dcca39f.svg";